import { AxiosInstance } from "axios";
import { TBENames, TBEVersion } from "./Axios.type";
import { AxiosFactory } from "./AxiosFactory";

export default class AxiosService {
  protected axios: AxiosInstance;

  constructor(type: TBENames, version: TBEVersion) {
    this.axios = AxiosFactory.getInstance(type, version);
  }
}
